import { QuickpayConstants } from 'constants/quickpay';
import { createAction } from 'redux-actions';

export const getQuickpayAction = createAction(QuickpayConstants.GET_QUICKPAY);
export const getPaymentAccountsAction = createAction(QuickpayConstants.GET_PAYMENT_ACCOUNTS);
export const addPaymentAccountAction = createAction(QuickpayConstants.ADD_PAYMENT_ACCOUNT);
export const getQuickpayStatusAction = createAction(QuickpayConstants.GET_STATUS);
export const makeQuickpayPaymentAction = createAction(QuickpayConstants.MAKE_QUICKPAY_PAYMENT);
export const getQuickpayAutopaysAction = createAction(QuickpayConstants.GET_AUTOPAYS);
export const scheduleQuickpayAutopayAction = createAction(QuickpayConstants.SCHEDULE_AUTOPAY);
export const validateBankRoutingNumber = createAction(QuickpayConstants.VALIDATE_BANK_ROUTING_NUMBER_QUICKPAY);
export const updateDebitCard = createAction(QuickpayConstants.UPDATE_DEBIT_CARD);
export const submitBorrowerSelfIdentificationAction = createAction(QuickpayConstants.SUBMIT_BORROWER_SELF_IDENTIFICATION);
export const getQuickpayCollateralSummaryAction = createAction(QuickpayConstants.GET_COLLATERAL_SUMMARY);
export const getQuickpayCollateralRequiredAction = createAction(QuickpayConstants.GET_COLLATERAL_REQUIRED);
export const getQuickpayLoanSetupAction = createAction(QuickpayConstants.GET_LOAN_SETUP);
